import { render } from "./ManufacturingWorkstation.vue?vue&type=template&id=3e39f2ae&scoped=true"
import script from "./ManufacturingWorkstation.vue?vue&type=script&lang=js"
export * from "./ManufacturingWorkstation.vue?vue&type=script&lang=js"

import "./ManufacturingWorkstation.vue?vue&type=style&index=0&id=3e39f2ae&scoped=true&lang=css"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e39f2ae"]])

export default __exports__